import { render } from "./AdditionalNotes.vue?vue&type=template&id=3ce265a0"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js"

import "./AdditionalNotes.vue?vue&type=style&index=0&id=3ce265a0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/AdditionalNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ce265a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ce265a0', __exports__)) {
    console.log('reload')
    api.reload('3ce265a0', __exports__)
  }
  
  module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=3ce265a0", () => {
    console.log('re-render')
    api.rerender('3ce265a0', render)
  })

}


export default __exports__